import { procedures } from "./types";
import {fetch,get,SelectComponent} from "./common";
import {forwardRef} from "react";

export const fetchProcedures = (...args)=>{
    return fetch(procedures,...args);
}

export const getProcedures = (...args)=>{
    return get(procedures,...args);
}

export const SelectProcedure = forwardRef((props,ref)=>{
    return <SelectComponent
        {...props}
        type = {procedures}
        ref = {ref}
    />
});

SelectProcedure.displayName = "SelectProcedure";